import React, {useState, useMemo, useEffect } from 'react';

import classes from './ChecklistSection.module.css';

import ChecklistItem from './ChecklistItem';
import GearCard from './GearCard';
import ShareChecklistItem from '../Share/ShareChecklistItem';


const ChecklistSection = ( { group, festivalInfo, section, filterMembers, readonly, handleDragStart, handleDragOver, handleDragEnd, searchQuery, onDetail, onShowToast, insertAfterFirstItem } ) => {

    
    const [items, setItems] = useState();


    //filter items according to which member/s has been seletced in the top filter
    useEffect(() => {
        const items = section.items?.filter((item,index) => {
            //apply filterMembers - if filter members includes anyone who has been assigned to this item
            let result = false;
            (item.organise || []).forEach(org => {
                if ( filterMembers.includes(org.assigned) ) result = true;
            });
            if (result) return item;
        });
        const sortedItems = items.sort(function(a, b) { return a.order - b.order; });
        const filtered = searchQuery 
          ? sortedItems.filter(item => item.name?.toLowerCase().includes(searchQuery.toLowerCase()))
          : sortedItems;
        setItems(filtered);
    }, [section, filterMembers, searchQuery]);

    
   

    return (
        <div className={classes.checklistSectionContainer}>
            { !readonly && items?.map((item, index) =>
                <React.Fragment key={item.id}>
                    <GearCard
                        group={group}
                        festivalInfo={festivalInfo}
                        item={item}
                        onDelete={(item) => console.log('delete', item.name)}
                        onDetail={onDetail}
                        onShowToast={onShowToast}
                        handleDragStart={handleDragStart}
                        handleDragOver={handleDragOver}
                        handleDragEnd={handleDragEnd}
                    />
                    {index === 0 && insertAfterFirstItem}
                </React.Fragment>
            )}
            { readonly && items?.map((item) =>
                <ShareChecklistItem
                    group={group}
                    key={item.id}
                    item={item}
                />
            )}
        </div>
    );

}

export default ChecklistSection;